/*
 * @Author: Teemo Ding
 * @Date: 2021-08-31 12:35:31
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-31 14:55:19
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/CustomerDBGetter/useGetCustomerDB.ts
 */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchDatabase,
  getIsCurrentDatabase,
  getCurrentDatabase,
} from './slice';
import { useParams } from 'react-router-dom';
import { get } from 'lodash';

const useFetchCurrentDatabase = (da?) => {
  const { uuid: oU, uuidKey, forceUpdate } = da || {};
  const p: any = useParams();
  const _uuid = p[uuidKey || 'uuid'];
  const uuid = oU || _uuid;
  const d = useDispatch();
  const isCurrentDatabase = useSelector(getIsCurrentDatabase(uuid));
  const currentDatabase = useSelector(getCurrentDatabase());
  const databaseUuid = get(currentDatabase, 'uuid');
  React.useEffect(() => {
    if (forceUpdate) {
      d(fetchDatabase({ databaseUuid: uuid }));
    }
  }, []);
  React.useEffect(() => {
    if (databaseUuid) {
      if (isCurrentDatabase) {
      } else {
        d(fetchDatabase({ databaseUuid: uuid }));
      }
    }
  }, [isCurrentDatabase]);
  return { database: currentDatabase || {} };
};
const useDatabase = () => {
  const s = useSelector(getCurrentDatabase());
  return s;
};
export { useFetchCurrentDatabase, useDatabase };
